import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const InstanceHealth = ({ instances = [] }) => {
    const list = Array.isArray(instances) ? instances : [];

    return (
        <div className="card mt-4">
            <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                    <div>
                        <h6 className="mb-0 text-lg">Instance health</h6>
                        <p className="mb-0 text-secondary-light text-sm">
                            Live connection status across your WhatsApp instances
                        </p>
                    </div>
                    <Link to="/instances" className="btn btn-sm btn-success">
                        Manage
                    </Link>
                </div>

                {list.length === 0 ? (
                    <div className="dash-empty" style={{ minHeight: 80 }}>
                        <Icon icon="logos:whatsapp-icon" />
                        <span>No instances yet</span>
                    </div>
                ) : (
                    <div className="d-flex flex-wrap gap-2">
                        {list.map((inst) => {
                            const state = inst.state || (inst.ready ? "connected" : "offline");
                            return (
                                <Link
                                    key={inst.id || inst.client_id}
                                    to="/instances"
                                    className="dash-instance-chip"
                                    title={inst.client_id}
                                >
                                    <span className={`dash-dot ${state}`} />
                                    <span>{inst.name || inst.client_id}</span>
                                    <span className="text-secondary-light text-xs text-capitalize">
                                        {state}
                                    </span>
                                </Link>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default InstanceHealth;
